var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobsMenuItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Jobs_Menu_Item",
    "data-name": "Jobs Menu Item",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-5);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.545,
    y1: 0.31,
    x2: 0.199,
    y2: 0.813,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0379a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0.59,
    x2: 0.618,
    y2: 1.299,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1.333,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: 0.411,
    x2: 0.049,
    y2: 0.866,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0379a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#04739e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1177"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Jobs_Menu_Item_-_Inactive_Collapsed_",
    "data-name": "Jobs Menu Item - Inactive (Collapsed)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MJM-Jobs",
    transform: "translate(0.444 0.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(-0.444 -0.425)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    className: "cls-1",
    cx: 20,
    cy: 20,
    r: 20
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    className: "cls-2",
    d: "M3.6,1.919a1.679,1.679,0,1,0,0,3.358h8.316a1.679,1.679,0,0,0,0-3.358H3.6M3.6,0h8.316a3.6,3.6,0,1,1,0,7.2H3.6A3.6,3.6,0,0,1,3.6,0Z",
    transform: "translate(11.344 5.835)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    className: "cls-3",
    width: 26.604,
    height: 18.491,
    rx: 9.245,
    transform: "translate(5.871 9.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_18",
    "data-name": "Union 18",
    className: "cls-4",
    d: "M3.3,1.913A1.3,1.3,0,0,0,1.983,3.189V15.3A1.3,1.3,0,0,0,3.3,16.577H23.3A1.3,1.3,0,0,0,24.621,15.3V3.189A1.3,1.3,0,0,0,23.3,1.913H3.3M3.3,0H23.3a3.248,3.248,0,0,1,3.3,3.189V15.3a3.249,3.249,0,0,1-3.3,3.189H3.3A3.248,3.248,0,0,1,0,15.3V3.189A3.248,3.248,0,0,1,3.3,0Z",
    transform: "translate(5.871 9.433)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(20.569 20.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    "data-name": "Line 5",
    className: "cls-5",
    d: "M-7.56-2.124a1.434,1.434,0,0,1-1.018-.422,1.439,1.439,0,0,1,0-2.035l4-4a1.439,1.439,0,0,1,2.036,0,1.439,1.439,0,0,1,0,2.035l-4,4A1.434,1.434,0,0,1-7.56-2.124Z",
    transform: "translate(8.999 17.077)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    className: "cls-1",
    cx: 5.758,
    cy: 5.757,
    rx: 5.758,
    ry: 5.757,
    transform: "translate(3.039 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_31_-_Outline",
    "data-name": "Ellipse 31 - Outline",
    className: "cls-6",
    d: "M5.758,1.919A3.838,3.838,0,1,0,9.6,5.757,3.838,3.838,0,0,0,5.758,1.919M5.758,0A5.757,5.757,0,1,1,0,5.757,5.757,5.757,0,0,1,5.758,0Z",
    transform: "translate(3.039 0)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    className: "cls-5",
    width: 26.604,
    height: 9.396,
    rx: 4.698,
    transform: "translate(5.871 9.433)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    className: "cls-1",
    width: 4.964,
    height: 6.889,
    rx: 2.482,
    transform: "translate(22.574 15.716) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsMenuItem);
export default __webpack_public_path__ + "static/media/jobs-menu-item.95b986d7b72aa2108ab52ab3b09f95e5.svg";
export { ForwardRef as ReactComponent };